import React, { Component } from "react";

import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import { Button, message,Input } from 'antd';
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';
import QRCode from 'qrcode.react';
import WidgetModal from "../../widget/WidgetModal";
import WidgetTable from "../../widget/WidgetTable";

let SystemType = Config.getSystemType();
class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            qrCodeImg: '',
            timer: null,
            ENTTYPE: '',
            QrNum: 0,
            modelOptions: {
                modalType: "form",
                title: '模拟登录',
                index: 0,
                width: '100%',
                message: null,
                isNext: false,
                isOk: true,
                wrapClassName: 'sg-index-model',
                okText: "关闭",
                bodyStyle: { padding: 0 },
            },
            isHide: true,
            columns: [
                { name: 'ZJ', title: '主键', type: 'string', description: '主键', properties: { hidden: true } },
                { name: 'UNISCID', title: '统一社会信用代码', type: 'string', description: '统一社会信用代码', properties: { hidden: true } },
                { name: 'ENTNAME', title: '模拟个体工商户名称', type: 'string', description: '模拟个体工商户名称', properties: { width: 220 } },
                {
                    name: "operation", title: "操作", type: "string", description: "操作", properties: {
                        operations: [
                            { name: "登录", click: "login" },
                        ]
                    },
                },
                { name: 'SBSTATE', title: '模拟申报状态', type: 'string', description: '模拟申报状态', properties: {} },
            ],
            tableOptions: {
                records: 10,
                check: false
            },
        }
    }
    componentDidMount() {
        this.getLoginToken();
    }
    componentWillUnmount() {
        clearInterval(this.timer)
    }
    getEntType() {
        let ENTTYPE = localStorage.getItem("ENTTYPE")
        if (ENTTYPE) {
            this.setState({
                ENTTYPE: ENTTYPE
            })
            this.getLoginToken()
        } else {
            message.warning('首次注册登录，请先查询申报资格');
        }

    }
    changeCanvasToPic = () => {
        let canvasImg = document.getElementsByTagName('canvas')[0];
        let image = new Image();
        image.src = canvasImg.toDataURL("image/png");
        //将canvas格式图片转换成image
        let alink = document.createElement("img");
        alink.className = 'sg-center-img';
        alink.id = "qr-img";
        alink.src = image.src;
        alink.download = "ceshi.png";
        let qrImg = document.getElementById('qr-img');
        if (qrImg) {
            canvasImg.parentNode.replaceChild(alink, qrImg);
        } else {
            canvasImg.parentNode.insertBefore(alink, canvasImg);
        }
    }
    getLoginToken() {
        this.getQrCode()
        // WidgetAjax.ajax({
        //     url : Config.getBasePath()+'/login', 
        //     params : {
        //         username: "admin",
        //         secret: "83F721314D0DCA74195F7AA79623F5FB"
        //     }, 
        //     callback : (data)=>{
        //         if(data&&data.access){
        //             //localStorage.setItem("_user_access_",data.access)
        //             this.getQrCode()
        //         }
        //     }
        // },this);
    }
    getQrCode() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/Qrcode/getQridUrl',
            params: undefined,
            callback: (data) => {
                if (data && data.status === 0) {
                    let qrinfo = JSON.parse(data.result.qrinfo)
                    this.setState({
                        qrCodeImg: `${process.env.NODE_ENV === 'development' ? data.result.jumpurl_test : data.result.jumpurl}${JSON.stringify(qrinfo)}`
                    })
                    setTimeout(() => {
                        this.changeCanvasToPic()
                    }, 400)

                    // this.timer = setInterval(()=>{
                    this.pollingGetQrState(data.result.qrid)
                    // },5000)
                }
            }
        }, this);
    }
    pollingGetQrState(qrid) {
        const { qrCodeExpired, QrNum } = this.state;
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/Qrcode/getQrState',
            params: { qrid },
            callback: (data) => {
                // 延迟5秒后执行
                setTimeout(() => {
                    if (data && data.message_header && data.message_header.errorInfo && data.message_header.errorInfo === '等待授权' && qrCodeExpired != true) {
                        if (QrNum == 35) {
                            return this.props.history.push({ pathname: "/home/index" });
                        }
                        this.setState({ QrNum: QrNum + 1 })
                        this.pollingGetQrState(qrid);
                    }
                }, 5000);

                if (data && typeof data === 'string') {
                    data = JSON.parse(data.replace(/[\n\r\r\n\t\\]+/g, ""))
                }

                if (data && data.message_content && data.message_content.type && data.message_content.type != null) {

                    if (data.message_content.type === '8' || data.message_content.uniscid === '91110112MA7HCNREXC') {
                        if (data.message_header.errorCode === 0 || data.message_header.errorCode === '0') {
                            localStorage.setItem("_user_info_", JSON.stringify(data.message_content))
                            localStorage.setItem("_user_access_", data.user_info.access)
                            this.queryAuditMaxnewinfo()
                        }
                    }
                    else {
                        clearInterval(this.timer);
                        // this.getQrCode.bind(this);
                        this.getQrCode();
                        return message.info({ content: "您当前使用的电子营业执照类型不是个体工商户,不符合平台登录填报的资格要求。如有问题,请咨询当地主管单位!", duration: 10 })
                    }
                }
            }
        }, this);
    }
    queryAuditMaxnewinfo() {
        // this.goPage()
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/audit_maxnewinfo',
            params: {},
            callback: (data) => {
                if (data && data.status === 0) {
                    if (data.result) {
                        if (data.result.PROVINCE && data.result.CITY && data.result.COUNTY) {
                            let arr = [data.result.PROVINCE, data.result.CITY, data.result.COUNTY]
                            let arrStr = [data.result.PROVINCESTR, data.result.CITYSTR, data.result.COUNTYSTR]
                            localStorage.setItem('defaultValue', arr.join(','))
                            localStorage.setItem('ProvincialUrbanAreas', arrStr.join(','))
                            localStorage.setItem('region', data.result.COUNTYSTR)
                        }
                    }
                    this.goPage()
                }
            }
        }, this);
    }
    onChange(value) {
        console.log(value);
    };
    // goPage() {
    //     window.history.back(-1)
    // };
    goPage() {
        this.props.history.replace({ pathname: "/home/index", state: {} });
        window.location.reload()
    };
    goQuery() {
        this.props.history.push({ pathname: "/home/query", state: {} });
    }
    goQuery2() {
        this.props.history.push({ pathname: "/home/info", state: {} });
    }
    onRef = (ref) => {
        this.modal = ref;
    };
    analog = () => {

        this.setState({
            data: [],
            username: null
        });

        this.modal.open();
    }
    queryList = () => {
        const { username, } = this.state;

        if (username && username !== "") {

            const onQueryList = (result, params) => {

                if (result.status === 0) {
                    this.setState({
                        data: result.results,
                    });
                }
                else {
                    message.error(result.message);
                }
            }

            let params = {
                SPUSERNAME: username,
                page: 1,
                records: 5
            }

            WidgetAjax.ajax({ url: Config.getBasePath() + '/entsq/analog_list', params: params, callback: onQueryList });

        }
        else {
            message.warning('请输入您的审批系统账号！');
        }
    }
    notify = (type, data, value, index, event, val) => {

        switch (type) {
            case "login":
                {
                    this.analogLogin(data);
                    break;
                }
        }
    }
    analogLogin = (item) => {

        const onAnalogLogin = (result, params) => {
            if (result) {
                if (result && typeof result === 'string') {
                    result = JSON.parse(result.replace(/\n|\r|\r\n|\t+/g, ""))
                }
                localStorage.setItem("_user_info_", JSON.stringify(result.message_content));
                
                if (result.user_info && result.user_info.access) {
                    localStorage.setItem("_user_access_", result.user_info.access)
                }
                this.queryAuditMaxnewinfo()
            }
            else {
                message.error(result.message);
            }

        }

        let params = {
            uniscid: item.UNISCID
        }

        WidgetAjax.ajax({ url: Config.getBasePath() + '/Qrcode/analog_login', params: params, callback: onAnalogLogin });
    }
    render() {
        const { qrCodeImg, modelOptions, isHide, username, data = [], columns, tableOptions } = this.state;
        return (
            <div data-component="login">
                <div className="sg-login">
                    <div className="sg-login-title">电子营业执照扫码登录</div>
                    <div className="sg-login-imgs" style={{ marginTop: '0.24rem' }}>
                        <img className='sg-imgs-img' alt='#' src={require('../../img/business/login.png')} />
                        <div className="sg-item-center sd-columnCenter">
                            <div className="sg-center-view" style={{ marginBottom: '0.14rem' }}>
                                <img className='sg-center-img' alt='#' src={require('../../img/business/code.png')} style={{ display: !qrCodeImg ? "block" : "none" }} />
                                <QRCode value={qrCodeImg} size={200} fgColor="#000000" id="qrCode" style={{ display: 'none' }}></QRCode>
                            </div>
                            {/* <div className="sg-bottom-tips">首次注册登录，请先<Button type="link" className="sg-tips-line" style={{padding:0}} onClick={()=>{this.goQuery()}}>查询</Button>申报资格</div> */}
                        </div>
                    </div>
                    {
                                SystemType != 'sso' ?
                                    <div className="sf-analog">
                                        <Button type="primary" style={{ marginTop: '20px' }} block size="large" onClick={this.analog}>模拟登录</Button>
                                        <div className="sg-login-tip">（仅在模拟环境中使用）</div>
                                    </div> : <></>
                            }
                    <div className="sg-login-bottom">
                        <div className="sg-bottom-font" style={{ marginBottom: '8px' }}>扫码须知</div>
                        <div className="sg-bottom-tips">1.请<span style={{ color: '#ff0000' }}>长按并识别登录二维码</span>，打开电子营业执照小程序。</div>
                        <div className="sg-bottom-tips">2.选择电子营业执照，输入个体工商户名称、统一社会信用代码等信息进行验证。</div>
                        <div className="sg-bottom-tips">3.验证通过后，点击“确认登录”，即可登录名特优新申报系统（如果提示二维码无效，请刷新此页面重新扫码登录）。</div>
                        <div className="sg-bottom-tips" style={{ marginTop: '10px' }}>没有电子营业执照，怎么办? <Button type="link" className="sg-tips-line" style={{ padding: 0 }} onClick={() => { this.goQuery2() }}>查看操作指南</Button></div>
                    </div>
                </div>
                <WidgetModal options={modelOptions} onRef={this.onRef} isHide={isHide}>
                    <div className="sg-modal-login sf-padding">
                        <div className="sg-center-middle sg-filter">
                            <div className="sg-middle-list sd-middle">
                                <Input placeholder="请输入您的审批系统帐号" bordered={false} value={username} onKeyUp={this.onKeyUp} onChange={(e) => this.setState({ username: e.target.value })} />
                            </div>
                            <div className="sg-middle-bottom">
                                <Button type="primary" style={{ marginTop: '0px' }} block size="large" onClick={this.queryList}> 获取登录信息</Button>
                            </div>
                        </div>

                        <div className="sg-contet">
                            {
                                data && data.length > 0 ? <div>
                                    <WidgetTable columns={columns} options={tableOptions}
                                        data={data} total={data.length} notify={(e, i) => { this.notify(e, i) }} check={false} isFooter={false} />
                                </div>
                                    :
                                    <>
                                        <div className="sg-tip">操作步骤:</div>
                                        <div className="sg-tip">第1步:输入您在审批系统中开通的账号</div>
                                        <div className="sg-tip">第2步:点击“获取登录信息”按钮，系统会自动分配给您5个模拟的个体工商户信息</div>
                                        <div className="sg-tip">第3步:选择其中一个模拟个体工商户进行登录</div>
                                    </>
                            }
                        </div>




                    </div>
                </WidgetModal>
            </div>
        )
    }
}

export default Index
